import { useDataStore } from "@/modules/pe-basic-module/data/store"
import { IHoneycombs } from "../../data/interfaces"

/* Protopia Ecosystem component */
export interface IHoneycombsProps {
   
}
const Honeycombs = (props: IHoneycombsProps): JSX.Element | false => {
    const honeycombs: IHoneycombs[] = useDataStore((state: any) => state.PEFestHoneycombs|| []) 
    return !!honeycombs.length && <section id="honeycombs">
        <div className='pe-honeycombs-container'>
       
        </div>        
    </section>
}
export default Honeycombs